module.exports = __webpack_public_path__ + "static/img/bg-best-director.9cafff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-best-director.jpg
// module id = 312
// module chunks = 0